/* eslint-disable no-param-reassign */
import Settings from '../settings/Settings';

export const PRESENCE_STATUS_DND = 'dnd';
export const PRESENCE_MESSAGE_DND = 'in conference';
export const PRESENCE_STATUS_AVAILABLE = 'available';

/**
 * Knows difference between what api returns and what need to pass to presence api
 */
export default class Presence {

    /**
     *
     * @param status
     * @param message
     * @param until
     */
    constructor(status, message, until) {
        this.status = status;
        this.message = message;
        this.until = until;
    }

    /**
     *
     * @returns {boolean}
     */
    isDnd() {
        return this.status === PRESENCE_STATUS_DND;
    }

    /**
     *
     * @returns {*}
     */
    get status() {
        return this._status;
    }

    /**
     *
     * @param status
     */
    set status(status) {
        this._status = !status ? PRESENCE_STATUS_AVAILABLE : status;
    }

    /**
     *
     * @returns {*}
     */
    get message() {
        return this._message;
    }

    /**
     *
     * @param message
     */
    set message(message) {
        // Always remove hidden symbols from message (WMS-16922)
        const invisibleChar = '‎';

        this._message = message === false ? '' : message.replace(invisibleChar, '');
    }

    /**
     *
     * @returns {*}
     */
    get until() {
        return this._until;
    }

    /**
     *
     * @param until
     */
    set until(until) {
        if (until && !(until instanceof Date)) {
            until = new Date(Date.parse(until));
        }
        if (until) {
            const utcOffset = until.getTimezoneOffset() * 60;

            until.setSeconds(until.getSeconds() + utcOffset);
        }

        this._until = Settings.formatApiDate(until);
    }
}
